import _defineProperty from "@babel/runtime/helpers/defineProperty";

var _CONTINUOUS_BLOCK;

export var UNSTYLED = 'unstyled';
export var OL = 'ordered-list';
export var OL_LI = 'ordered-list-item';
export var UL = 'unordered-list';
export var UL_LI = 'unordered-list-item';
export var TODO = 'todo-block';
export var TODOS = 'todo-blocks';
export var H1 = 'header-one';
export var H2 = 'header-two';
export var H3 = 'header-three';
export var H4 = 'header-four';
export var H5 = 'header-five';
export var H6 = 'header-six';
export var CODE = 'code-block';
export var CODES = 'code-blocks';
export var QUOTE = 'quote-block';
export var QUOTES = 'quote-blocks';
export var SEPARATOR = 'separator';
export var EMBED = 'embed';
export var EMBED_PLACEHOLDER = 'embed-placeholder';
export var IMAGE = 'image';
export var IMAGE_GALLERY = 'image-gallery';
export var FILE = 'file';
export var PDF = 'pdf';
export var TABLE_CELL = 'table-cell';
export var TABLE = 'table';
export var DATABASE = 'database';
export var INTEGRATION_TILE = 'integration-tile';
export var INTEGRATION_SUGGESTION = 'integration-suggestion';
export var HINT = 'hint';
export var HINTS = 'hints';
export var TEMPORARY_BLOCK = 'TEMPORARY_BLOCK';
export var HEADER_BLOCKS = [H1, H2, H3];
export var TYPOGRAPHIC_BLOCKS = [].concat(HEADER_BLOCKS, [UNSTYLED, UL, UL_LI, OL, OL_LI, TODO, TODOS]);
export var CONTINUOUS_BLOCK = (_CONTINUOUS_BLOCK = {}, _defineProperty(_CONTINUOUS_BLOCK, TODO, TODOS), _defineProperty(_CONTINUOUS_BLOCK, UL_LI, UL), _defineProperty(_CONTINUOUS_BLOCK, OL_LI, OL), _defineProperty(_CONTINUOUS_BLOCK, CODE, CODES), _defineProperty(_CONTINUOUS_BLOCK, QUOTE, QUOTES), _defineProperty(_CONTINUOUS_BLOCK, TABLE_CELL, TABLE), _defineProperty(_CONTINUOUS_BLOCK, IMAGE, IMAGE_GALLERY), _defineProperty(_CONTINUOUS_BLOCK, HINT, HINTS), _CONTINUOUS_BLOCK);
export var RESET_COUNTER_BLOCKS = [].concat(HEADER_BLOCKS, [UNSTYLED, SEPARATOR]);
export var OT_BLOCKS = [UNSTYLED, OL_LI, UL_LI, TODO, H1, H2, H3, H4, H5, H6, CODE, QUOTE, SEPARATOR, EMBED, EMBED_PLACEHOLDER, IMAGE, FILE, PDF, TABLE_CELL, DATABASE, INTEGRATION_TILE, HINT];
export var VOID_BLOCKS = [INTEGRATION_TILE, IMAGE, EMBED, SEPARATOR, FILE, DATABASE, PDF]; // Blocks who can be transformed into another one from this same list

export var MUTABLE_BLOCKS = [UNSTYLED, OL_LI, UL_LI, TODO, H1, H2, H3, QUOTE, CODE, HINT];
export default {
  UNSTYLED: UNSTYLED,
  OL: OL,
  OL_LI: OL_LI,
  UL: UL,
  UL_LI: UL_LI,
  TODO: TODO,
  TODOS: TODOS,
  H1: H1,
  H2: H2,
  H3: H3,
  CODE: CODE,
  CODES: CODES,
  QUOTE: QUOTE,
  QUOTES: QUOTES,
  SEPARATOR: SEPARATOR,
  EMBED: EMBED,
  EMBED_PLACEHOLDER: EMBED_PLACEHOLDER,
  IMAGE: IMAGE,
  IMAGE_GALLERY: IMAGE_GALLERY,
  FILE: FILE,
  TABLE_CELL: TABLE_CELL,
  TABLE: TABLE,
  INTEGRATION_TILE: INTEGRATION_TILE,
  INTEGRATION_SUGGESTION: INTEGRATION_SUGGESTION,
  DATABASE: DATABASE,
  HINT: HINT,
  HINTS: HINTS,
  PDF: PDF
};